export default __webpack_public_path__ + "static/media/gallery-1.5e974b7c.jpg";